import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Row, Col, Label, Alert, Overlay, Popover } from 'react-bootstrap';
import moment from 'moment';
import 'moment-timezone';

import { getColor } from 'helpers/charts';
import generateId from 'helpers/id';

import LeadHeaderItems from 'components/layout/lead/LeadHeaderItems';
import ClientInfos from 'components/layout/client/ClientInfos';
import OrderInfos from 'components/layout/order/OrderInfos';
import IntlDate from 'components/layout/IntlDate';
import IntlDateRelative from 'components/layout/IntlDateRelative';

class LeadHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showColorSelector: false,
      pickerId: generateId('color-picker-'),
    };

    this.colorSelectorRef = React.createRef();
  }

  showColorSelector = () => {
    this.setState({ showColorSelector: true });
  };

  closeColorSelector = () => {
    this.setState({ showColorSelector: false });
  };

  selectColor = color => {
    const { updateEntity } = this.props;
    this.closeColorSelector();
    updateEntity('color', color * 10 + 1);
  };
  ItSetInternalComment = (e) => {
    const { updateEntity } = this.props;
    let name = "internalComment"
    updateEntity(name, e);


  }

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      inModal,
    } = this.props;
    const { showColorSelector, pickerId } = this.state;

    const colors = Array(9)
      .fill(null)
      .map((_, i) => i);

    if (entityLoaded) {
      const momentWeekAgo = moment()
        .subtract(7, 'days')
        .startOf('day');
      const createdDate = moment(entity.getCdate()).isAfter(momentWeekAgo) ? (
        <IntlDateRelative date={entity.getCdate()} />
      ) : (
        <IntlDate date={entity.getCdate()} />
      );

      let status;
      if (entity.getIsWon()) {
        status = (
          <Label bsStyle="success" className="m-r-20" style={{ fontSize: 'inherit' }}>
            {messages.won}
          </Label>
        );
      } else if (entity.getIsLost()) {
        status = (
          <Label bsStyle="danger" className="m-r-20" style={{ fontSize: 'inherit' }}>
            {messages.lost}
          </Label>
        );
      } else if (entity.getIsDeleted()) {
        status = (
          <Label bsStyle="danger" className="m-r-20" style={{ fontSize: 'inherit' }}>
            {messages.deleted}
          </Label>
        );
      } else {
        status = (
          <Label bsStyle="info" className="m-r-20" style={{ fontSize: 'inherit' }}>
            {messages.open}
          </Label>
        );
      }

      // check if we have any items to show
      let leadItems = [];
      if (entity.getItems().length) {
        leadItems = entity.getItems();
      }
      let leadItemCodes = [];
      if (entity.getItemCodes().length) {
        leadItemCodes = entity.getItemCodes();
      }
      const HeaderComponent = inModal ? 'h5' : 'h3';
      let shippingOutput = [];
      if(entity.getOrders().length) {
        let shippingMethod = entity.getOrders()[0].shipping;

        if (shippingMethod === "standard") {
          shippingOutput.push(<div><i className="fad fa-fw fa-circle" style={{color: "grey"}}></i> Standardversand
          </div>);
        } else if (shippingMethod === "express") {
          shippingOutput.push(<div><i className="fad fa-fw fa-circle" style={{color: "orange"}}></i> Express</div>);
        } else if (shippingMethod === "overnight") {
          shippingOutput.push(<div><i className="fad fa-fw fa-circle" style={{color: "#CF1719"}}></i> Overnight</div>);
        } else {
          shippingOutput.push(<div><i className="fad fa-fw fa-circle"
                                      style={{color: "#000000"}}></i> {shippingMethod} keine Versandart hinterlegt
          </div>);
        }
      }



      return (
        <div className="clearfix">
          <HeaderComponent>
            {status}
            <span>
              <i
                class="fad fa-circle cursor"
                style={{ color: '#' + getColor(entity.getColor(), 81) }}
                ref={this.colorSelectorRef}
                onClick={this.showColorSelector}
              />{' '}
              {entity.getTitle()}
            </span>
            <span className="hint-text fs-13">
              <i className="fa fa-calendar m-r-5 m-l-15" />
              {createdDate}
            </span>
          </HeaderComponent>
          <Row>
            <Col {...(inModal ? { xs: 12 } : { xs: 12, sm: 4 })}>
              {entity.getTarget().getUsername() ? (
                <div className="card card-default bg-master-lighter padding-20 sm-padding-10 b-rad-sm">
                  <div className="font-secondary fs-12 all-caps m-b-10">{messages.client}</div>
                  <ClientInfos entity={entity.getTarget()} addEditAction inModal={inModal} />
                </div>
              ) : (
                <Alert bsStyle="info">{messages.no_client_assigned}</Alert>
              )}
            </Col>

            <Col {...(inModal ? { xs: 12 } : { xs: 12, sm: 4 })}>
              {!!leadItems.length && (
                <div className="card card-default bg-master-lighter padding-20 sm-padding-10 b-rad-sm">
                  <div className="font-secondary fs-12 all-caps m-b-10">{messages.items}</div>
                  <LeadHeaderItems items={leadItems} entityLoaded={entityLoaded} inModal={inModal} shippingOutput={shippingOutput} />
                </div>

              )}
              {!!leadItemCodes.length && (
                <div
                  className={
                    'card card-default bg-master-lighter padding-20 sm-padding-10 b-rad-sm ' +
                    (leadItems.length ? 'm-t-15 ' : '')
                  }
                >
                  <div className="font-secondary fs-12 all-caps m-b-10">{messages.items}</div>
                  <ul>
                    {leadItemCodes.map(itemCode => (
                      <li key={itemCode}>{itemCode}</li>
                    ))}
                  </ul>
                </div>
              )}

              {!leadItems.length && !leadItemCodes.length && (
                <Alert bsStyle="info">{messages.no_products_assigned}</Alert>
              )}


            </Col>

            <Col {...(inModal ? { xs: 12 } : { xs: 12, sm: 4 })}>
              {entity.getOrders().length ? (
                <div className="card card-default bg-master-lighter padding-20 sm-padding-10 b-rad-sm">

                  <div className="font-secondary fs-12 all-caps m-b-10">{messages.order}</div>

                  <div style={{display:"flex"}}>
                    <OrderInfos
                      entity={entity.getOrders()[entity.getOrders().length - 1]}
                      entityLoaded={entityLoaded}
                      addEditAction
                      inModal={inModal}
                      pipeline={entity?.getPipeline?.()}
                    />

                    <div className="internal_comment" style={{ margin: '0px 10px 10px 10px' }}>
                      <label>
                        <strong>Interne Bemerkung</strong>
                        <textarea
                          id="internalComment"
                          name="internalNote"
                          rows="7"
                          cols="45"
                          className="internalNoteClass"
                          onChange={e => this.ItSetInternalComment(e.target.value)}
                          value={entity.getInternalComment() || ''}
                        />
                      </label>
                    </div>
                  </div>

                  {entity.getOrders().length > 1 && (
                    <div className="p-t-10 text-center">
                      <FormattedMessage
                        id="plus_count_more"
                        values={{
                          count: entity.getOrders().length - 1,
                        }}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <Alert bsStyle="info">{messages.no_order_assigned}</Alert>
              )}
            </Col>
          </Row>

          <Overlay
            show={showColorSelector}
            target={this.colorSelectorRef.current}
            placement="bottom"
            rootClose
            onHide={this.closeColorSelector}
          >
            <Popover id={pickerId} style={{ maxWidth: 'none', zIndex: 1200 }}>
              <Row style={{ width: '140px' }}>
                {colors.map(color => {
                  return (
                    <Col xs={4} className="no-padding text-center" key={color}>
                      <HeaderComponent>
                        <i
                          class="fad fa-circle cursor"
                          style={{ color: '#' + getColor(color * 10 + 1, 81) }}
                          onClick={() => this.selectColor(color)}
                        />
                      </HeaderComponent>
                    </Col>
                  );
                })}
              </Row>
            </Popover>
          </Overlay>
        </div>
      );
    }

    return null;
  }
}

export default withRouter(injectIntl(LeadHeader));
